import { createAsyncThunk } from "@reduxjs/toolkit";
import { InventoryAxios } from "api/InventoryAxios";

import { WarehouseAxios } from "api/WarehouseAxios";
import axios from "axios";
// import { Axios } from "api/WarehouseAxios";

export const InventoryfetchInStock = createAsyncThunk(
  "InventoryInStock/InventoryfetchInStock",
  async ({
    page,
    pageSize,
    sort,
    order,
    search,
    filters,
  }: {
    page: number;
    pageSize: number;
    search?: string;
    sort?: string;
    order?: "asc" | "desc" | "";
    filters?: any;
  }) => {
    const params = new URLSearchParams();
    params.append("page", page.toString());
    params.append("page_size", pageSize.toString());
    if (search) params.append("search", search);
    if (sort) {
      const orderingValue = order === "desc" ? `-${sort}` : sort;
      params.append("ordering", orderingValue);
    }

    if (filters && filters.length > 0) {
      filters.forEach(
        ({
          filterField,
          filterValue,
        }: {
          filterField: string;
          filterValue: any;
        }) => {
          if (
            filterField &&
            filterValue !== undefined &&
            filterValue !== null
          ) {
            if (typeof filterValue === "object" && filterValue !== null) {
              Object.entries(filterValue).forEach(([key, value]) => {
                if (value !== undefined && value !== null && value !== "") {
                  params.append(key, String(value));
                }
                if (
                  (filterValue.from_date || filterValue.to_date) &&
                  (filterField === "created_at" || filterField === "updated_at")
                ) {
                  if (filterField === "created_at") {
                    filterField = "created";
                  } else {
                    filterField = "updated";
                  }
                  params.append("filter_by", filterField);
                }
              });
            } else {
              params.append(filterField, filterValue);
            }
          }
        }
      );
    }
    // const response: any = await WarehouseAxios.get(
    //   `/warehouse/dailyLogs/?${params.toString()}`
    // );

    const response: any = await InventoryAxios.get(
      `/warehouse/dispatch/warehouse-overview/in-stock/?${params.toString()}`
    );
    console.log("resp In Stock of : ", response);
    return {
      data: response?.data?.data || [],
      // data: response?.data,
      // rowCount: response.count,
      rowCount: response.data.count || 0,
    };
  }
);

export const InventoryStockTransferStockCSV = async () => {
  const response = await InventoryAxios.get(
    "/warehouse/dailyLogs/?export=csv",
    {
      responseType: "blob",
    }
  );

  return {
    blob: response.data,
    filename:
      response.headers["content-disposition"]
        ?.split("filename=")[1]
        ?.replace(/"/g, "") || "purchaseRequest.csv",
  };
};

export const InventoryStockfetchTransferOptionsByWarehouseType = async (
  warehouseTye: string
) => {
  try {
    const response = await InventoryAxios.get("");
    return response.data;
  } catch (err: any) {
    // return rejectWithValue(err.response.data || "Fetch Failed");
  }
};

export const InventoryaddStockTransferCreate = createAsyncThunk(
  "block/InventoryaddStockTransferCreate",
  async (stockData: any, { rejectWithValue }) => {
    try {
      // const response: any = await InventoryAxios.post(
        // `api/stock-transfer-request/create/`,
         const response: any = await WarehouseAxios.post(
          `/stock/create/`,
        stockData,
        {
          headers: {
            "Content-Type": "form-data/" 
          }
        }
      );
      console.log("response while addign block : ", response);
      return response.data;
    } catch (err: any) {
      console.log("err in catch of thunk: ", err);
      // throw err
      return rejectWithValue(
        err.response?.data || { message: "Failed to add block" }
      );
      // return err.response?.data || "Failed to add block";
    }
  }
);
